import React from "react";
import { useSelector } from "react-redux";
import { Route, Redirect, withRouter } from "react-router-dom";

import { Loading } from "components/StatusScreen";

// Signed-in pages. Guests go to the login and come back here afterwards.
const MemberRoute = ({ component: Component, location, ...rest }) => {
  const user = useSelector((state) => state.users);

  return (
    <Route
      {...rest}
      render={(props) =>
        user === null ? (
          <Loading />
        ) : user ? (
          <Component {...props} />
        ) : (
          <Redirect to={`/login?path=${encodeURIComponent(location.pathname + location.search)}`} />
        )
      }
    />
  );
};

export default withRouter(MemberRoute);
